module.exports = __webpack_public_path__ + "img/upper pocket button diameter.5164d9ba.png";